import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@carbon/react';

const BreakdownSectionTable = ({ headers, rows }) => (
  <Table size="sm">
    <TableHead>
      <TableRow>
        {headers.map((header) => (
          <TableHeader key={header.key}>{header.title}</TableHeader>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
      {rows.map((row, index) => (
        <TableRow key={index}>
          {headers.map(({ key }, index) => (
            <TableCell key={key}>{index === 0 ? <strong>{row[key]}</strong> : row[key]}</TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default BreakdownSectionTable;
